// extracted by mini-css-extract-plugin
module.exports = {"note":"style_note__1_mk7A9N4NM3A37IoRO0uh","checkboxNote":"style_checkboxNote__Mhq_MBUXNZ2bD0DvWg9vt","header":"style_header__nuvaZUaUMAv4S9Vnyxf3r"};